import Trend from './Trend';
import './Trend.scss';

export default Trend;